import script from "./CurationEditButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CurationEditButton.vue?vue&type=script&setup=true&lang=js"

import "./CurationEditButton.vue?vue&type=style&index=0&id=01972fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01972fbe"]])

export default __exports__